import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Lightbulb14 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={14}
    contrast={contrast}
    className={className}
  >
    <path
      d='M4.91406 5.97478L6.11606 7.17679C6.15855 7.21927 6.20332 7.25805 6.25 7.29314V9H7.75V7.29306C7.79664 7.25799 7.84138 7.21924 7.88383 7.17679L9.08583 5.97478L8.02517 4.91412L6.99995 5.93935L5.97472 4.91412L4.91406 5.97478Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.75 5.5C1.75 2.58579 4.08579 0.25 7 0.25C9.91421 0.25 12.25 2.58579 12.25 5.5C12.25 6.79008 11.458 7.85121 10.705 8.82558C10.437 9.17231 10.2078 9.46881 10.0303 9.7588C9.82319 10.097 9.75 10.3294 9.75 10.5V13C9.75 13.4142 9.41421 13.75 9 13.75H5C4.58579 13.75 4.25 13.4142 4.25 13V10.5C4.25 10.3294 4.17681 10.097 3.96974 9.7588C3.79219 9.46881 3.56306 9.17235 3.29508 8.82563C2.54198 7.85124 1.75 6.7901 1.75 5.5ZM7 1.75C4.91421 1.75 3.25 3.41421 3.25 5.5C3.25 6.25382 3.75673 6.97133 4.47335 7.89704C4.73777 8.23862 5.02494 8.60959 5.24901 8.97557C5.3916 9.20846 5.52754 9.46814 5.62175 9.75H8.37825C8.47246 9.46814 8.6084 9.20846 8.75099 8.97557C8.97506 8.60959 9.26223 8.23862 9.52665 7.89705C10.2433 6.97133 10.75 6.25382 10.75 5.5C10.75 3.41421 9.08579 1.75 7 1.75ZM8.25 11.25H5.75V12.25H8.25V11.25Z'
      fill='currentColor'
    />
  </Svg>
);

Lightbulb14.displayName = 'Lightbulb14';
export default Lightbulb14;
